import { SelectCentroCusto, SelectFuncionario } from 'global/components/Selects'
import { useStore } from 'store'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import DigitacaoToolbar from './toolbar'

export default function CentroCustosToolbar() {
    const { view } = useDigitacaoContext()
    const centroCustoId = useStore(state => state.costCenterId)

    return (
        <DigitacaoToolbar>
            <SelectCentroCusto variant="standard" width={320} />
            {view === 'mensal' && (
                <SelectFuncionario
                    width={320}
                    size="small"
                    variant="standard"
                    centroCustoId={centroCustoId}
                    button
                    ativos
                />
            )}
        </DigitacaoToolbar>
    )
}
